import { useEffect, useState } from "react";

import { getAdminDescriptorsByEnrollment } from "../../../../User/services";

const PAGE_SIZE = 100;

// Fetches ALL billing descriptors under the enrollment (ignoring page filters),
// paginating until the full list is collected. Used only while the modal is open.
const useBulkDescriptors = (enrollmentId, enabled) => {
  const [descriptors, setDescriptors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !enrollmentId) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);

      const collected = [];
      let page = 1;
      let count = Infinity;

      while (collected.length < count) {
        const res = await getAdminDescriptorsByEnrollment({
          enrollment_id: enrollmentId,
          page,
          page_size: PAGE_SIZE,
        });

        if (!res?.ok) break;

        const results = res.data?.results || [];
        count = res.data?.count ?? results.length;
        collected.push(...results);

        if (!results.length) break;
        page += 1;
      }

      if (!cancelled) {
        setDescriptors(collected);
        setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [enrollmentId, enabled]);

  return { descriptors, loading, setDescriptors };
};

export default useBulkDescriptors;
